/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, {useCallback, useEffect, useState, useRef} from "react";
import { Container, Row, Button,Col } from "react-bootstrap";
import "./Contactus.css";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import axios from "axios";
import MediaQuery from "react-responsive";
import content from '../content.json';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
 
export default function Contactus({ links,loanPurpKeyword,
    noteRate,
    formHeading,
    showLeadFormModal,
    onHide,
    offerTerm, dataJson, realtorData, loanOfficerData}) {
      const [disclaimer, setDisclaimer] = useState("");
  const [showFormModal, setShowFormModal] = useState(false);
  const [loanPurposeKwd, setLoanPurposeKwd] = useState("");
  const [frmHeading, setFrmHeading] = useState("");
  const ref = useRef();
  const [isIntersecting, setIntersecting] = useState(false);
  const [footerInfoData, setFooterInfoData] = useState();
  const [loInfo, setLoInfo] = useState(null); // Initialize loInfo as null
  const [loanOfficerUid, setLoanOfficerUid] = useState('');
  const { loName } = useParams();
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const { formTitle, disclaimer: rawDisclaimer } = dataJson;
  
    const currentDate = new Date();
    const day = currentDate.getDate().toString().padStart(2, '0'); // Ensure two digits for day
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits for month (Note: January is 0)
    const year = currentDate.getFullYear();
    let hour = currentDate.getHours(); // Get the hour in 24-hour format
    const minute = currentDate.getMinutes().toString().padStart(2, '0'); // Ensure two digits for minute
    let meridiem = 'AM'; // Initialize meridiem to AM
  
    // Convert the hour to 12-hour format and set the meridiem accordingly
    if (hour >= 12) {
      meridiem = 'PM';
      hour = hour % 12 || 12; // Convert 0 to 12 for noon
    }
  
    const formattedDate = `${month}/${day}/${year}`; // Format date as MM/DD/YYYY
    const formattedTime = `${hour}:${minute} ${meridiem}`; // Format time as HH:MM AM/PM
  
    const updatedDisclaimer = rawDisclaimer.replace(
      "**CURRENT_DATE_TIME**",
      `${formattedDate} ${formattedTime}`
    );
  
    setDisclaimer(updatedDisclaimer);
  }, [dataJson]);

  useEffect(() => {
   
    const fetchSWMCFooterInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_SWMC_FOOTET_INFO)
          .then((response) => {
            //console.log(response.data);
            setFooterInfoData(response.data);
            const observer = new IntersectionObserver(([entry]) => {
              if (entry.isIntersecting) {
                setIntersecting(entry.isIntersecting);
                observer.disconnect();
              }
            });
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return () => {
              observer.disconnect();
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchSWMCFooterInfo();
  }, []); 

  useEffect(() => {
    // Fetch LO details JSON from a JSON endpoint
    const fetchLoInfo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_LO_DETAILS_CASHOUTREFI_JSON}`); // Replace with your JSON endpoint URL
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        // Find the LO details by matching the URL parameter
        const matchingLoInfo = data.find(lo => lo.url === loName);
        if (matchingLoInfo) {
          setLoInfo(matchingLoInfo); // Set the LO info
          setLoanOfficerUid(matchingLoInfo.loanofficerUid); // Set the loanOfficerUid
        } else {
          // Handle the case where no matching LO Name is found
          // You can set an error state or handle it as needed
        }
      } catch (error) {
        console.error('Error fetching LO info:', error);
        // Handle the error, e.g., set an error state
      }
    };

    fetchLoInfo(); // Call the fetch function when the component mounts
  }, [loName]); // Fetch whenever loName changes
  
  const handleApplyNowModal = () => {
    setShowFormModal(true);
    setLoanPurposeKwd("");
    setFrmHeading("Apply Now");
  };
  const [node, setNode] = useState(null);
  const formRef = useCallback((node) => {
          // node refers to the name input field in the BorrowerLeadGenerationTool
       setNode(node);
       }, []);
  const handleCloseFormModal = () => setShowFormModal(false);

  const imgCDNURL = process.env.REACT_APP_HOMEOWNERSHIP_PROGRAM_CDN_URL ;
  const {formTitle} = dataJson;
  const realtorLoId = loanOfficerData ? loanOfficerData.ssid : "";

  // const { loName } = useParams();
  // const loInfo = loData.find(lo => lo.url === loName);

  useEffect(() => {
    if (node) {
    
      const messageInput = document.getElementById("message");

      messageInput.placeholder = "Message";
      messageInput.ariaPlaceholder = "Message";
      const iconSpan = document.createElement("span");
      iconSpan.classList.add("message-icon-new");
      messageInput.parentNode.insertBefore(iconSpan, messageInput.nextSibling);

      const emaiInput = document.getElementById("email");
      emaiInput.placeholder = "Email ID";
      emaiInput.ariaPlaceholder = "Email ID";
      const iconSpan1 = document.createElement("span");
      iconSpan1.classList.add("email-icon-new");
      emaiInput.parentNode.insertBefore(iconSpan1, emaiInput.nextSibling);

      const phoneInput = document.getElementById("phone");
      phoneInput.placeholder = "Phone Number";
      phoneInput.ariaPlaceholder = "Phone Number";
      const iconSpan2 = document.createElement("span");
      iconSpan2.classList.add("phone-icon-new");
      phoneInput.parentNode.insertBefore(iconSpan2, phoneInput.nextSibling);

      const firstnameInput = document.getElementById("firstName");
      const iconSpan3 = document.createElement("span");
      iconSpan3.classList.add("name-icon-new");
      firstnameInput.parentNode.insertBefore(iconSpan3, firstnameInput.nextSibling);

      const lastnameInput = document.getElementById("lastName");
      const iconSpan4 = document.createElement("span");
      iconSpan4.classList.add("name-icon-new");
      lastnameInput.parentNode.insertBefore(iconSpan4, lastnameInput.nextSibling);
    
      
    }
  }, [node]); 

  return (
    <>
     <Container>
          <Row className="lastpara">
          <Col className="" xs ={12} sm={12} md={12} xl={12} xxl={12} lg={12}>
          <p className="disclaimertext">{parse(disclaimer)}
          
      </p></Col>
          </Row>
        </Container>
     <Container>
      <Row className="borrtoolrow p-5">
        <Col xs={12} sm={12} md={12} xl={1} xxl={1} lg={1}></Col>
        <Col className="borrleadtoolcol" xs ={11} sm={12} md={12} xl={12} xxl={12} lg={12}>
            <div className="request">
              <p className="requestpara">{parse(formTitle)}</p>
            </div>
      <BorrowerLeadGenerationTool
          leadSource="Self"
          branch=""
          showModalBackBtn={false}
          // statesDomain={process.env.REACT_APP_STATE_DOMAIN}
          ref={formRef}
          loanOfficerUid={realtorLoId}
          mainBtnName="Send Message"
        />    
        </Col>
        <Col sm={12} md={12} xl={1} xxl={1} lg={1}></Col>
        </Row>
      </Container>
    </>
  );
}
